import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AssessmentMockService } from './services/assessment-mock.service';
import { AssessmentStage } from './models/assessment.model';

/** Sub-path for each stage; invalid/closed render on the landing route. */
const PATH: Record<AssessmentStage, string> = {
  invalid: '', closed: '', landing: '', pay: 'pay', questions: 'q', thanks: 'thanks',
};

@Injectable({ providedIn: 'root' })
export class AssessmentStageGuard implements CanActivate {
  constructor(private svc: AssessmentMockService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const token = route.paramMap.get('token')!;
    const requested = route.data['stage'] as AssessmentStage;
    const actual = this.svc.stageFor(token);
    const target = (actual === 'invalid' || actual === 'closed') ? 'landing' : actual;
    if (requested === target) { return true; }
    return this.router.createUrlTree(['/assessments', token, ...(PATH[target] ? [PATH[target]] : [])]);
  }
}
